import * as React from 'react';

export interface QuizContext {
  quizType: 'personal' | 'workspace';
  quizId: number;
  workspaceId?: string;
  workspaceQuizId?: string;
}

const QuizEditorQuizContext = React.createContext<QuizContext>({
  quizType: 'personal',
  quizId: null,
  workspaceId: null,
  workspaceQuizId: null,
});

interface Props extends QuizContext {
  children: React.ReactNode;
}

export function QuizContextProvider({
  quizId,
  quizType,
  workspaceQuizId,
  workspaceId,
  children,
}: Props) {
  return (
    <QuizEditorQuizContext.Provider
      value={{ quizId, quizType, workspaceQuizId, workspaceId }}
    >
      {children}
    </QuizEditorQuizContext.Provider>
  );
}

export function useQuizContext() {
  const value = React.useContext(QuizEditorQuizContext);
  if (value === undefined) {
    throw new Error(
      'Quiz Context is not defined. Ensure this component is wrapped inside a QuizContextProvider component'
    );
  }
  return value;
}
